<div class="bar-entry" *ngIf="bar" (click)="viewDetails()">
  <!-- Encabezado con nombre y rating -->
  <div class="bar-header">
    <div class="bar-info">
      <h3 class="bar-name">{{ bar.name }}</h3>
      <div class="bar-meta" *ngIf="bar.type || bar.priceRange">
        <span class="bar-type" *ngIf="bar.type">{{ bar.type }}</span>
        <span class="bar-price" *ngIf="bar.priceRange">{{ bar.priceRange }}</span>
      </div>
    </div>
    <div class="bar-rating" *ngIf="bar.rating" [class]="'rating-' + ratingColor">
      <div class="rating-value">{{ bar.rating.toFixed(1) }}</div>
      <div class="rating-stars">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
          <polygon points="12 2 15.09 10.26 23.77 10.36 17.39 16.88 19.54 25.64 12 20.12 4.46 25.64 6.61 16.88 .23 10.36 8.91 10.26 12 2"/>
        </svg>
      </div>
    </div>
  </div>

  <!-- Ubicación -->
  <div class="bar-location" *ngIf="bar.location || bar.address">
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
      <circle cx="12" cy="10" r="3"></circle>
    </svg>
    <span>{{ bar.address || bar.location }}</span>
  </div>

  <!-- Estado de apertura -->
  <div class="bar-status" *ngIf="bar.regularOpeningHours && bar.regularOpeningHours.length > 0">
    <div class="status-badge" [class]="isOpenNow ? 'open' : 'closed'">
      <span class="status-dot"></span>
      <span class="status-text">{{ isOpenNow ? 'Abierto ahora' : nextOpeningTime }}</span>
    </div>
  </div>

</div>
